module.exports = __webpack_public_path__ + "static/media/fill.aae1bc6c.svg";